export const formatTime = (seconds) => {
  if (seconds == null) return '--:--';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

export const getScoreData = (answers) => {
  if (!Array.isArray(answers) || answers.length === 0) return null;
  const graded = answers.filter(a => a.isCorrect !== null);
  if (graded.length === 0) return null;
  const correct = graded.filter(a => a.isCorrect === true).length;
  return { correct, total: graded.length, percent: Math.round((correct / graded.length) * 100) };
};

export const getInitials = (name) => {
  if (!name) return '?';
  return name.charAt(0).toUpperCase();
};

export const getViolationColor = (count) => {
  if (count === 0) return { bg: '#e8f5e9', color: '#2e7d32', label: 'Clean' };
  if (count <= 3) return { bg: '#fff3e0', color: '#e65100', label: `${count} Flags` };
  return { bg: '#fdecea', color: '#c62828', label: `${count} Flags ⚠️` };
};

export const getScoreColor = (percent) => {
  if (percent >= 80) return { bg: '#e8f5e9', color: '#2e7d32' };
  if (percent >= 60) return { bg: '#fff3e0', color: '#e65100' };
  return { bg: '#fdecea', color: '#c62828' };
};
